enum TypeSpecialtyProfessionalEnum {
  UNIQUE = 'Unique',
  GENERAL = 'General',
}

export default TypeSpecialtyProfessionalEnum;
